import script from "./CategorySortGame.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySortGame.vue?vue&type=script&setup=true&lang=js"

import "./CategorySortGame.vue?vue&type=style&index=0&id=53b0a679&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b0a679"]])

export default __exports__